export default __webpack_public_path__ + "static/media/Privacy-Unlocked.f4d32af2.svg";